import {
    IId,
    IItemWithId,
    IPaginatedQuery,
} from './types';

class Entity {
    public static findOneById<IItem extends IItemWithId>(id: IId | null | undefined, items: IItem[] | null | undefined): IItem | null {
        if (id === null) {
            return null;
        }
        if (!items) {
            return null;
        }

        return items.find((item) => item.id === id) ?? null;
    }

    public static paginateInfinity<IItem extends IItemWithId>(query: IPaginatedQuery, items: IItem[] | null, newItems: IItem[] | null | undefined): IItem[] | null {
        if (!newItems) {
            return items;
        }
        if (!query.skip) {
            return newItems;
        }

        return [...(items ?? []), ...newItems];
    }

    public static insert<IItem extends IItemWithId>(newItem: IItem | null | undefined, items: IItem[] | null): IItem[] | null {
        if (!items) {
            return items;
        }
        if (!newItem) {
            return items;
        }

        return [newItem, ...items];
    }

    public static push<IItem extends IItemWithId>(newItem: IItem | null | undefined, items: IItem[] | null): IItem[] | null {
        if (!items) {
            return items;
        }
        if (!newItem) {
            return items;
        }

        return [...items, newItem];
    }

    public static replace<IItem extends IItemWithId>(newItem: IItem | null | undefined, items: IItem[] | null): IItem[] | null {
        if (!items) {
            return items;
        }
        if (!newItem) {
            return items;
        }

        const index = items.findIndex((item) => item.id === newItem.id);

        if (index === -1) {
            return items;
        }

        const newItems = [...items];

        newItems[index] = newItem;

        return newItems;
    }

    public static delete<IItem extends IItemWithId>(id: IId, items: IItem[] | null): IItem[] | null {
        if (!items) {
            return items;
        }

        return items.filter((item) => item.id !== id);
    }

    public static incrementTotal(total: number | null): number | null {
        if (total === null) {
            return total;
        }

        return total + 1;
    }

    public static decrementTotal(total: number | null): number | null {
        if (total === null) {
            return total;
        }
        if (total <= 0) {
            return 0;
        }

        return total - 1;
    }
}

export default Entity;
